import { replacerCost } from 'utils/replacerCost';

import type React from 'react';

export type TabItem = {
    id: TabsIds;
    label: string;
};

export const enum TabsIds {
    COMMON = 'COMMON',
    PRICE = 'PRICE',
    FORMULA = 'FORMULA',
    TEMPLATE = 'TEMPLATE',
}

export const tabsItems = [
    { id: TabsIds.COMMON, label: 'Общие данные' },
    { id: TabsIds.PRICE, label: 'Лимиты по расчету' },
    { id: TabsIds.FORMULA, label: 'Формула' },
    { id: TabsIds.TEMPLATE, label: 'Шаблон' },
];

export const requiredMessage = { message: 'Обязательное поле' };
export const totalCostErrorMessage = { message: 'Сумма лимитов не должна быть равна нулю' };

export const invisibleStyle: React.CSSProperties = {
    visibility: 'hidden',
    position: 'absolute',
    overflow: 'hidden',
    maxHeight: 0,
};

export const tableEmptyDataText = 'Для отображения данных создайте прочие затраты';

export type CalculatingOtherDistributionItem = {
    id: boolean;
    label: string;
    disabled?: boolean;
};

export const OTHER_DISTRIBUTING_METHOD_LIMITS: CalculatingOtherDistributionItem[] = [
    {
        id: false,
        label: 'Автоматически',
    },
    {
        id: true,
        label: 'Вручную',
    },
];

export type CalculatingParticipationItem = {
    id: boolean;
    label: string;
};

export const CALCULATING_PARTICIPATION_VARIANTS: CalculatingParticipationItem[] = [
    {
        id: true,
        label: 'Учитывать',
    },
    {
        id: false,
        label: 'Не учитывать',
    },
];

export const CALCULATION_NOT_BEEN_COMPLETED_MESSAGE = 'Не завершена работа с Расчетом НМЦ';
export const MAX_INTEGER_PART_LENGTH_MESSAGE = 'Длина целой части должна быть не более 12 знаков';

export const nmdcPercentRules = {
    validate: (value: string | number | null | undefined) => {
        if (value === null || value === undefined || value === '') {
            return true;
        }

        const num = replacerCost(value);

        if (Number.isNaN(num)) {
            return 'Недопустимое значение';
        }

        if (num < 0) {
            return 'Недопустим ввод отрицательного значения';
        }

        if (num >= 1000) {
            return 'Значение должно быть в диапазоне от 0 до 999';
        }

        return true;
    },
};
